import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../context/Auth/AuthContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { signed, loading, user } = useAuth();

  if (loading) {
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '14px'
    }}>
      Carregando...
    </div>;
  }

  if (!signed || !user) {
    return <Redirect to="/login" />;
  }

  if (user?.super !== true) {
    return <Redirect to="/forbidden" />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default PrivateRoute;
